<a href="javascript:void(0)" class="sort-icons" (click)="changeSort()" draggable="false">
    <span class="icon" [ngClass]="{'active': isSort('asc')}"><i class="far fa-long-arrow-alt-up"></i></span>
    <span class="icon" [ngClass]="{'active': isSort('desc')}"><i class="far fa-long-arrow-alt-down"></i></span>
    <span class="ms-1 text-white">{{columnName}}</span>
</a>